import Intercom from "@intercom/messenger-js-sdk";
import { useAuth } from "@/hooks/useAuth";
import { useUser } from "@/hooks/useUser";

export default function LiveChat() {
  const { user: authUser } = useAuth();
  const { user } = useUser(authUser?.uid);
  Intercom({
    app_id: "r6o6n9c3",
    user_id: user?.uid, // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
    name: user?.displayName, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
    email: user?.email, // IMPORTANT: Replace "user.email" with the variable you use to capture the user's email
    created_at: user?.registeredAt, // IMPORTANT: Replace "user.createdAt" with the variable you use to capture the user's sign-up date in a Unix timestamp (in seconds) e.g. 1704067200
  });

  return <></>;
}
